import * as React from "react";
const SvgInfo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.1 10.2A1.9 1.9 0 1 1 18 8.3c.1 1.1-.8 1.9-1.9 1.9m1.4 2.6v-1.3h-3.9v1.3h1.3v10.9h-1.3V25h5.1v-1.3h-1.3V12.8zM16.1 0a16 16 0 0 1 16 16.1c0 8.9-7.2 16.1-16.1 16.1S0 24.9 0 16.1C0 7.2 7.2 0 16.1 0m14 16.1c0-7.8-6.3-14.1-14-14.1C8.3 2 2 8.3 2 16.1a14 14 0 0 0 14.1 14c7.7 0 14-6.3 14-14"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfo;
